import isNode from "detect-node";

export const requireFetchIfNeeded = () => {
  /* fetch is added for testing(jest)
    createHttpLink requires some implementation of fetch 
    when running outside the browser */
  return isNode ? require("node-fetch") : undefined;
};
